<template>
<div class="col-xs-12">
  <div class="card float-e-margins">
    <div class="card-title">
        <h1>Banner</h1>
    </div>
    <div class="card-content no-padding">
      <vc-alert v-if="success" type="success"
         :timeout="4000">
      {{successMessage}}
      </vc-alert>
      <vc-alert v-if="error" type="danger" :dismissible="false">
         Er is een fout opgetreden!
      </vc-alert>
      <div class="table-responsive">
        <div class="card-title card-header form-horizontal">
          <label>Aantal banners: {{total}} </label>
          <div class="form-group">
            <label class="control-label col-sm-1" style="text-align:left;" for="filter">Filter op : </label>
            <div class="col-sm-4">
              <input type="text" class="form-control" id="filter" placeholder="Filter" v-model="filterKey">
            </div>
            <button class="btn btn-success" @click="showCustomModal = true">Voeg banner toe</button>
          </div>
        </div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th v-for="(key, val) in columns">
                <a @click="sortBy(val)" class="arrow" :class="active: sortKey == column">
                  {{ key | capitalize }}
                </a>
              </th>
          </thead>
          <tbody>
            <tr v-for="banner in adminConfigs | filterBy filterKey | orderBy sortKey reverse">
              <td>
                <input v-if="edit" type="text" class="form-control" id="BannerDesc" v-model="banner.Type">
                <p v-else style="white-space:pre-line;"><small>{{ banner.Type }}</small></p>
              </td>
              <td>
                <input v-if="edit" type="text" class="form-control" id="BannerDesc" v-model="banner.Description">
                <p v-else style="white-space:pre-line;"><small>{{ banner.Description }}</small></p>
              </td>
              <td>
                <div class="ios">
                  <vui-toggle name="wifi" :checked.sync="banner.Enabled" @change="setAvailable(banner)"></vui-toggle>
                </div>
                <p v-if="banner.Enabled" class="text-success">Aan</p>
                <p v-else class="text-danger">Uit</p>
              </td>
              <td width="10%">
                <button type="button" class="btn btn-danger" @click="selectBanner(banner)">Verwijder</button>
                <button v-if="edit" type="button" class="btn btn-success" @click="updateBanner(banner)">Opslaan</button>
                <button v-else type="button" class="btn btn-primary" @click="edit = true">Wijzig</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<vm-delete :callback.sync="remove" :show.sync="showdeltemodal"></vm-delete>
<v-modal :show.sync="showCustomModal" effect="fade" width="400">
  <div slot="modal-header" class="modal-header">
    <h4 class="modal-title">
      <b>Nieuwe banner toevoegen</b>
    </h4>
  </div>
  <div slot="modal-body" class="modal-body">
    <div class="form-group">
      <label for="BannerType">Banner Titel:</label>
      <input type="text" class="form-control" id="BannerType" v-model="newBanner.Type" placeholder="bijvoorbeeld: Vakantie, Actie etc.">
    </div>
    <div class="form-group">
      <label for="BannerDesc">Banner Beschrijving:</label>
      <input type="text" class="form-control" id="BannerDesc" v-model="newBanner.Description">
    </div>
    <div class="form-group">
      <label for="BannerName">Banner direct aan?:</label>
      <label><input type="checkbox" v-model="newBanner.Enabled"></label>
    </div>
  </div>
  <div slot="modal-footer" class="modal-footer">
    <button type="button" class="btn btn-success" @click="save()">Opslaan</button>
    <!-- after save start -->
    <vc-alert v-if="modalsuccess" type="success"
      :timeout="4000">
      Banner succesvol toegevoegd!
    </vc-alert>
    <vc-alert v-if="modalerror" type="danger" :dismissible="false">
       Er is een fout opgetreden!
    </vc-alert>
    <!-- after save end -->
  </div>
</v-modal>
</template>
<script>
import store from '../../store'
import callbackalert from '../Common/CallbackAlert'
import toggle from '../Common/Toggle'
import deletemodal from '../Common/deleteSweetAlert'
import modal from '../Common/Modal'
export default {
  route: {
    canReuse: false
  },
  components: {
    'vc-alert': callbackalert,
    'vui-toggle': toggle,
    'vm-delete': deletemodal,
    'v-modal': modal
  },
  data () {
    return {
      store: store,
      adminConfigs: {},
      success: false,
      error: false,
      successMessage: 'Banner succesvol bijgewerkt!',
      columns: {
        'Titel': 'Type',
        'Omschrijving': 'Description',
        'Status': 'Enabled',
        ' ': 'Actions'
      },
      sortKey: '',
      reverse: 1,
      showdeltemodal: false,
      selectedBanner: null,
      filterKey: '',
      showCustomModal: false,
      edit: false
    }
  },
  created () {
    this.getAdminConfigs()
  },
  methods: {
    getAdminConfigs: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/AdminConfigs',
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.adminConfigs = response
        }.bind(this)
      })
    },
    remove: function () {
      console.log('Verwijderd~!')
      $.ajax({
        type: 'DELETE',
        url: store.root + 'api/AdminConfigs/' + this.selectedBanner.ConfigId,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
        this.AdminConfigs.$remove(this.selectedBanner)
        this.selectedBanner = null
        this.showdeltemodal = false
        console.log('Verwijderd~!')
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.success = false
        this.error = true
      }.bind(this))
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? this.reverse * -1 : -1
      this.sortKey = sortKey
    },
    setAvailable: function (item) {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/AdminConfigs/' + item.ConfigId,
        data: item,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        console.log('change Available succesfully done!')
      })
      .fail(function (response) {
        console.log(response)
      })
    },
    selectBanner: function (val) {
      this.selectedBanner = val
      this.showdeltemodal = true
    },
    save: function () {
      $.ajax({
        type: 'POST',
        url: store.root + 'api/AdminConfigs',
        data: this.newBanner,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.modalsuccess = true
        this.modalerror = false
        setTimeout(function () { location.reload(true) }, 2000)
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.modalsuccess = false
        this.modalerror = true
      }.bind(this))
    },
    updateBanner: function (item) {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/AdminConfigs/' + item.ConfigId,
        data: item,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
        this.edit = false
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.error = true
        this.success = false
      }.bind(this))
    }
  },
  computed: {
    total: function () {
      return this.adminConfigs.length
    }
  }
}
</script>


// WEBPACK FOOTER //
// adminconfig.vue?43819200